import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Container } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';

import { Auth } from '../support';
import ApiKeys from '../cuenta/keys/ApiKeys';
import Profile from '../cuenta/perfil/Profile';
import Paquetes from '../cuenta/comprar/Paquetes';
import Sucursal from '../cuenta/sucursal/Sucursal';
import Empresas from '../cuenta/empresas/Empresas';
import GuardianRoute from '../shared/GuardianRoute';
import AccountSidebar from './sidebar/AccountSidebar';
import PageError403 from '../shared/errors/PageError403';
import PageError404 from '../shared/errors/PageError404';
import HttpErrorMonitor from '../support/HttpErrorMonitor';
import EmpresasInfo from '../cuenta/empresas/EmpresasInfo';
import LandingCompra from '../cuenta/comprar/LandingCompra';
import EmpresasUpsert from '../cuenta/empresas/EmpresasUpsert';
import Preferencias from '../cuenta/preferencias/Preferencias';
import LicenseDetails from '../cuenta/licencia/LicenseDetails';
import ConfigCardAdd from '../cuenta/configuracion/ConfigCardAdd';
import NavBarHeader from './components/navbar-header/NavBarHeader';
import SucursalUpsert from '../cuenta/sucursal/upsert/SucursalUpsert';
import BuyPackage from '../cuenta/comprar/hits/components/BuyPackage';
import ConfigActivation from '../cuenta/configuracion/ConfigActivation';
import LandingCompraConfirm from '../cuenta/comprar/LandingCompraConfirm';
import ConfigBillinginfo from '../cuenta/configuracion/ConfigBillinginfo';
import ShoppingHistory from '../cuenta/historial-compras/ShoppingHistory';
import ConfigConfirmation from '../cuenta/configuracion/ConfigConfirmation';
import ShoppingHistoryInfo from '../cuenta/historial-compras/ShoppingHistoryInfo';
import SessionOverrideHighlighter from '../shared/session/SessionOverrideHighlighter';
import PanelConfiguraciones from '../cuenta/panel-configuraciones/PanelConfiguraciones';
import BuyPackageUsingTransfer from '../cuenta/comprar/hits/components/BuyPackageUsingTransfer';
import ConfirmBuyPackageTransfer from '../cuenta/comprar/hits/components/ConfirmBuyPackageTransfer';
import AccountSuspendedHighlighter from '../admin/clientes/list/components/AccountSuspendedHighlighter';
import EmisoresSoonToExpireHighlighter from '../app/emisores/EmisoresSoonToExpireHighlighter';

class AccountLayout extends Component {
  state = {
    openConfig: false,
    openSidebar: false,
  };

  constructor(props) {
    super(props);

    const { empresa = {} } = Auth.getData() || {};

    this.state = {
      live: empresa.live || false,
      openConfig: props.location.pathname.indexOf('/cuenta/config') !== -1,
    };
  }

  componentDidMount() {
    window.setAppTitle('Mi cuenta');
  }

  handleConfigClick = (event) => {
    this.setState({
      openConfig: !this.state.openConfig,
    });

    this.props.history.push('/cuenta/config/activacion');
  };

  handleOnToggleSidebar = (state = null) => {
    state = state !== null ? state : !this.state.openSidebar;

    this.setState({
      openSidebar: state,
    });
  };

  render() {
    const { live } = this.state;
    const { openConfig } = this.state;
    const { openSidebar } = this.state;

    if (!Guardian.allows('profile.access')) {
      return <PageError403 />;
    }

    const sidebarClassName = !!openSidebar ? 'sidebar-open' : '';

    return (
      <Container
        fluid
        className={`app-wrapper ${sidebarClassName}`}
      >
        <NavBarHeader
          fluid={false}
          onToggleSidebar={this.handleOnToggleSidebar}
        />

        <HttpErrorMonitor />

        <AccountSuspendedHighlighter />

        <EmisoresSoonToExpireHighlighter />

        <SessionOverrideHighlighter />

        <div
          className="sidebar-backdrop"
          onClick={this.handleOnToggleSidebar.bind(this, false)}
        ></div>

        <div className="d-block d-lg-none d-xl-none">
          <AccountSidebar
            live={live}
            openConfig={openConfig}
            onOpenConfigRequest={this.handleConfigClick}
            onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
          />
        </div>

        <div className="app-container container">
          <div className="d-none d-lg-flex d-xl-flex">
            <AccountSidebar
              live={live}
              openConfig={openConfig}
              onOpenConfigRequest={this.handleConfigClick}
              onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
            />
          </div>

          <div className="main-container">
            <div className="page-container">
              <Switch>
                <GuardianRoute
                  path="/cuenta/perfil"
                  component={Profile}
                  can="perfil.listar"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/keys"
                  component={ApiKeys}
                  can="account.api-keys"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/empresas"
                  component={Empresas}
                  can="empresas.listar"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/empresas/registrar"
                  component={EmpresasUpsert}
                  can="empresas.crear"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/empresas/:id/info"
                  component={EmpresasInfo}
                  can="empresas.info"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/empresas/:id/editar"
                  component={EmpresasUpsert}
                  can="empresas.editar"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/forma-de-pago"
                  component={ConfigCardAdd}
                  can="cuenta.administrar.tarjeta"
                  exact
                />
                <Route
                  path="/cuenta/comprar/:id/landing"
                  component={LandingCompra}
                  exact
                />
                <Route
                  path="/cuenta/comprar/:id/result"
                  component={LandingCompraConfirm}
                  exact
                />
                <GuardianRoute
                  path="/cuenta/preferencias-hits"
                  component={Preferencias}
                  can="hits.asignar"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/config/activacion"
                  component={ConfigActivation}
                  can="cuenta.activar"
                  exact
                />
                <Route
                  path="/cuenta/config/confirmacion"
                  component={ConfigConfirmation}
                  exact
                />
                <GuardianRoute
                  path="/cuenta/historial-compra"
                  component={ShoppingHistory}
                  can="consumo.listar"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/historial-compra/:id/info"
                  component={ShoppingHistoryInfo}
                  can="consumo.info"
                  exact
                />
                <Route
                  path="/cuenta/historial-compra/:id/confirm"
                  component={ConfirmBuyPackageTransfer}
                  exact
                />
                <GuardianRoute
                  path="/cuenta/paquetes"
                  component={Paquetes}
                  can="compra.listar"
                  exact
                />
                <Route
                  path="/cuenta/paquetes/:pk"
                  component={BuyPackage}
                  can="compra.comprar"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/paquetes/:pk/transferencia"
                  component={BuyPackageUsingTransfer}
                  can="compra.pago.transferencia"
                  exact
                />
                <GuardianRoute
                  path="/cuenta/config/informacion-de-facturacion"
                  component={ConfigBillinginfo}
                  can="cuenta.informacion.fiscal"
                  exact
                />
                <Route
                  path="/cuenta/licencia"
                  component={LicenseDetails}
                  exact
                />

                <GuardianRoute
                  path="/cuenta/sucursal"
                  component={Sucursal}
                  can="sucursal.listar"
                  exact
                />

                <GuardianRoute
                  path="/cuenta/sucursal/registrar"
                  component={SucursalUpsert}
                  can="sucursal.crear"
                  exact
                />

                <Route
                  path="/cuenta/panel-configuraciones"
                  component={PanelConfiguraciones}
                />

                <Route
                  path="*"
                  component={PageError404}
                />
              </Switch>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default AccountLayout;
